import authAxios from "../utils/authAxios";

const dictionaryClient = {
    getWord: async (word, locale, translateLocale) => {
        const requestBody = {
            word: word,
            locale: locale,
            translateLocale: translateLocale,
        };

        return await authAxios(`/api/dictionary/`, {
            method: 'POST',
            data: requestBody,
            headers: {
                'Content-Type': 'application/json',
            },
        });
    },
};

export default dictionaryClient;
